<ng-container *ngIf="desktop | async">
  <div class="section_9">
    <div class="content">
      <div class="links">
        <div class="list">
          <div class="list-header">
            <ng-container i18n>EXPLORE</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/explore-hostels']" aria-label="Blog">
                <ng-container i18n>Hostels</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/blog']" aria-label="Blog">
                <ng-container i18n>Blog</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>RESOURCES</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/help']" fragment="talk-to-us" aria-label="Talk to us">
                <ng-container i18n>Talk to us</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/help']" aria-label="FAQ">
                <ng-container i18n>FAQs</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/blog']" aria-label="Press">
                <ng-container i18n>Press</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>ABOUT US</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/about-us']" aria-label="Our story">
                <ng-container i18n>Our story</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/careers']" aria-label="Careers">
                <ng-container i18n>Careers</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>WORK WITH US</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/hostel-signup']" aria-label="Hostel signup">
                <ng-container i18n>Hostel signup</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/ambassador-program']" aria-label="Ambassador program">
                <ng-container i18n>Ambassador program</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/affiliate-program']" aria-label="Affiliate program">
                <ng-container i18n>Affiliate program</ng-container>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <div class="contact-left">
          <a [routerLink]="['/']"  aria-label="Homepage" aria-label="Home">
            <svg-icon [svgStyle]="{'width.px': 319, 'height.px': 66}" src="/assets/icons/logo-dark.svg"></svg-icon>
          </a>
        </div>
        <div class="contact-right">
          <div class="cta-header">
            <ng-container i18n>Sign up to our newsletter</ng-container>
          </div>
          <div class="cta-form">
            <input placeholder="Email" class="input-inline" [(ngModel)]="email" />
            <button class="btn btn-theme btn-large" (click)="inviteBackpacker()">
              <span>
                <ng-container i18n>Stay updated</ng-container>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!(desktop | async)">
  <div class="section_9-sm">
    <div class="content">
      <a [routerLink]="['/']" class="logo" aria-label="Home">
        <svg-icon [svgStyle]="{'width.px': 230, 'height.px': 48}" src="/assets/icons/logo-dark.svg"></svg-icon>
      </a>
      <div class="links">
        <div class="list">
          <div class="list-header">
            <ng-container i18n>EXPLORE</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/explore-hostels']" aria-label="Blog">
                <ng-container i18n>Hostels</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/blog']" aria-label="Blog">
                <ng-container i18n>Blog</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>RESOURCES</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/help']" fragment="talk-to-us" aria-label="Talk to us">
                <ng-container i18n>Talk to us</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/help']" aria-label="FAQ">
                <ng-container i18n>FAQs</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/blog']" aria-label="Press">
                <ng-container i18n>Press</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>ABOUT US</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/about-us']" aria-label="Our story">
                <ng-container i18n>Our story</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/careers']" aria-label="Careers">
                <ng-container i18n>Careers</ng-container>
              </a>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list-header">
            <ng-container i18n>WORK WITH US</ng-container>
          </div>
          <div class="list-items">
            <div>
              <a [routerLink]="['/hostel-signup']" aria-label="Hostel signup">
                <ng-container i18n>Hostel signup</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/ambassador-program']" aria-label="Ambassador program">
                <ng-container i18n>Ambassador program</ng-container>
              </a>
            </div>
            <div>
              <a [routerLink]="['/affiliate-program']" aria-label="Affiliate program">
                <ng-container i18n>Affiliate program</ng-container>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="cta-form">
        <div class="title">
          <ng-container i18n>Sign up to our newsletter</ng-container>
        </div>
        <input placeholder="Email" class="input-inline" [(ngModel)]="email" />
        <div class="button-wrapper">
          <button class="btn btn-theme btn-large" (click)="inviteBackpacker()">
            <span>
              <ng-container i18n>Stay updated</ng-container>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
